import browserHistory from 'helpers/history'

function navigateToLibrary() {
	browserHistory.push('/library/' + window.location.search)
}

export {
	navigateToLibrary,
}
